module.exports = __webpack_public_path__ + "img/skills.ffea8d7c.jpeg";